// Inline SVG icons used across the landing page.
// Pure presentational components — no state, no props (aside from optional className).

export const AppleIcon = () => (
  <svg width="14" height="17" viewBox="0 0 32 38" fill="none" aria-hidden="true">
    <path
      d="M26.2264 20.0113C26.1825 15.2574 30.2187 12.9446 30.4033 12.8369C28.1174 9.5875 24.5744 9.14352 23.3293 9.10812C20.3536 8.8028 17.4672 10.8442 15.9513 10.8442C14.4052 10.8442 12.0709 9.13762 9.55512 9.18777C6.31768 9.23645 3.28902 11.064 1.62794 13.9019C-1.80011 19.6883 0.756555 28.1917 4.04089 32.8689C5.68381 35.1596 7.60358 37.7172 10.1164 37.6272C12.5747 37.5284 13.493 36.0991 16.4596 36.0991C19.399 36.0991 20.2613 37.6272 22.8241 37.5697C25.4624 37.5284 27.1235 35.2687 28.7089 32.9574C30.6075 30.3319 31.37 27.7462 31.4002 27.6135C31.3382 27.5928 26.2763 25.7092 26.2264 20.0113Z"
      fill="currentColor"
    />
    <path
      d="M21.3854 6.03127C22.7076 4.4191 23.6122 2.22577 23.3611 0C21.4474 0.0826 19.0541 1.29063 17.6759 2.8674C16.4566 4.25685 15.3674 6.53425 15.6488 8.67595C17.7985 8.8323 20.0057 7.61837 21.3854 6.03127Z"
      fill="currentColor"
    />
  </svg>
);

export const AndroidIcon = () => (
  <svg width="16" height="17" viewBox="0 0 35 38" fill="none" aria-hidden="true">
    <path
      d="M0.700605 0.585646C0.256825 1.03921 0 1.74537 0 2.65986V35.2795C0 36.194 0.256825 36.9002 0.700605 37.3537L0.810134 37.4533L19.532 19.1817V18.7503L0.810134 0.478712L0.700605 0.585646Z"
      fill="url(#asaro-ps-a)"
    />
    <path
      d="M25.7656 25.2753L19.532 19.1817V18.7503L25.7732 12.6567L25.9129 12.736L33.3042 16.842C35.4136 18.0072 35.4136 19.9247 33.3042 21.0974L25.9129 25.196L25.7656 25.2753Z"
      fill="url(#asaro-ps-b)"
    />
    <path
      d="M25.9129 25.196L19.5319 18.966L0.700562 37.3537C1.40117 38.0728 2.54366 38.1594 3.8429 37.4404L25.9129 25.196Z"
      fill="url(#asaro-ps-c)"
    />
    <path
      d="M25.9129 12.736L3.8429 0.491649C2.54366 -0.220038 1.40117 -0.133384 0.700562 0.585678L19.5319 18.966L25.9129 12.736Z"
      fill="url(#asaro-ps-d)"
    />
    <defs>
      <linearGradient id="asaro-ps-a" x1="17.8697" y1="35.6192" x2="-6.87723" y2="10.2726" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00A0FF" />
        <stop offset="0.0066" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient id="asaro-ps-b" x1="36.051" y1="18.9639" x2="-0.504247" y2="18.9639" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient id="asaro-ps-c" x1="22.4431" y1="15.5793" x2="-11.1157" y2="-18.7928" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient id="asaro-ps-d" x1="-4.03969" y1="48.2061" x2="10.9459" y2="32.8576" gradientUnits="userSpaceOnUse">
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);

export const ArrowIcon = () => (
  <svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path
      d="M3 7h8M7.5 3.5L11 7l-3.5 3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="M2.5 6.2l2.2 2.3L9.5 3.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DragIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M8 2v12M2 8h12M5 5l-3 3 3 3M11 5l3 3-3 3"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
